import { Add, ArrowBack } from '../../../Material/index'
import { AppBar, createTheme, IconButton, ThemeProvider, Toolbar, Typography } from '@mui/material'
import cn from 'classnames'
import colors from 'colors'

type SidebarHeaderMobileProps = {
  onClick?: () => void
  hideCloseButton?: boolean
  title: string
  leftArrowClick?: () => void
}

export const SidebarHeaderMobile = ({
  onClick,
  leftArrowClick,
  title
}: SidebarHeaderMobileProps) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: colors['blue-bb']
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="sticky">
        <Toolbar className={cn('topBarContainer')}>
          <IconButton title="Voltar" aria-label="Back" onClick={leftArrowClick}>
            <ArrowBack className="text-white-bb" />
          </IconButton>
          <Typography
            component="div"
            sx={{
              flexGrow: 1,
              fontFamily: 'BB-Font-Bold',
              fontSize: ' 22px',
              fontStyle: 'normal',
              lineHeight: '28px',
              margin: '0px 6px'
            }}
          >
            {title}
          </Typography>

          <IconButton title="Adicionar" className="iconContainer" color="inherit" onClick={onClick}>
            <Add />
          </IconButton>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  )
}
